"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRoutePath = exports.generateAppPath = exports.processPathname = exports.getPath = exports.getPlainPath = exports.setDefaultRoute = void 0;
const window_or_global_1 = __importDefault(require("window-or-global"));
const url_parse_1 = __importDefault(require("url-parse"));
const locale_1 = require("./locale");
let defaultRoute = '/home';
function setDefaultRoute(route) {
    defaultRoute = route;
}
exports.setDefaultRoute = setDefaultRoute;
function getPlainPath() {
    // allow trailing slash in route match, http://website and http://website/
    let path = '/';
    if (window_or_global_1.default.appContext && window_or_global_1.default.appContext !== '' && window_or_global_1.default.appContext !== '/') {
        // set path to the defined context
        path = window_or_global_1.default.appContext;
    }
    return path;
}
exports.getPlainPath = getPlainPath;
function getPath() {
    const plainPath = getPlainPath();
    const path = plainPath[plainPath.length - 1] === '/' ? plainPath : `${plainPath}/`;
    return path;
}
exports.getPath = getPath;
function processPathname(url) {
    const locale = (0, locale_1.getLocale)(); // en-US
    let urlWithLeadingSlash = url;
    if (url[0] !== '/') {
        urlWithLeadingSlash = `/${url}`;
    }
    //get the path from the url
    const fullUrl = (0, url_parse_1.default)(urlWithLeadingSlash, false);
    const queries = fullUrl.query;
    const hash = fullUrl.hash;
    let standardizedPath = fullUrl.pathname; // buy-now/battle-royale
    let context = getPlainPath(); // appContext i.e. /fortnite
    //add a leading slash if not present
    if (context[0] !== '/') {
        context = `/${context}`;
    }
    //remove trailing slash
    if (standardizedPath.length > 1 && standardizedPath[standardizedPath.length - 1] === '/') {
        standardizedPath = standardizedPath.substr(0, standardizedPath.length - 1) || '/';
    }
    // Strip off the context of requested route i.e. /home from /fortnite/home
    if (standardizedPath && standardizedPath.indexOf(context) === 0) {
        //cut the context out of the standardizedPath
        if (standardizedPath === context || standardizedPath.substr(0, context.length + 1) === `${context}/`) {
            standardizedPath = standardizedPath.substr(context.length) || '/';
        }
        //cut slash locale out of the standardizedPath
        if (standardizedPath.indexOf(`/${locale}/`) === 0 || standardizedPath === `/${locale}`) {
            standardizedPath = standardizedPath.substr(`/${locale}`.length) || '/';
        }
        //cut the locale out of the standardizedPath
        if (standardizedPath.indexOf(locale) === 0) {
            standardizedPath = standardizedPath.substr(locale.length) || '/';
        }
    }
    // Strip the leading / off the requested route (it is optional)
    let routePath = standardizedPath.indexOf('/') === 0 ? standardizedPath.substr(1) : standardizedPath;
    // append queryParams
    if (fullUrl && queries && queries.length) {
        const fullUrlStr = fullUrl.toString();
        if (fullUrlStr && fullUrlStr.length && fullUrlStr.indexOf('?') !== -1) {
            const parts = fullUrlStr.split('?');
            if (parts[1] && parts[1].length) {
                routePath += `?${parts[1]}`;
            }
        }
    }
    return `${routePath}${hash}`;
}
exports.processPathname = processPathname;
function generateAppPath(name) {
    let pathName = name;
    if (!name || name === '/' || name === '') {
        pathName = defaultRoute;
    }
    const routePath = processPathname(pathName);
    const path = getPath();
    return `${path}${routePath}`;
}
exports.generateAppPath = generateAppPath;
function generateRoutePath(name, dontIncludeLocale) {
    if (dontIncludeLocale)
        return generateAppPath(name);
    let pathName = name;
    if (!name || name === '/' || name === '') {
        pathName = defaultRoute;
    }
    const routePath = processPathname(pathName);
    const locale = (0, locale_1.getLocale)();
    const path = getPath();
    return `${path}${locale}/${routePath}`;
}
exports.generateRoutePath = generateRoutePath;
//# sourceMappingURL=route.js.map